import { Box, Paper, Popper, styled } from "@mui/material";

export const DropdownItemContainer = styled("div")(({ theme }) => ({
  cursor: "pointer",
  fontSize: "14px",
  padding: ".25rem .25rem",
  marginBlock: ".1rem",
  position: "relative",
  transition: "all 150ms linear",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: "5px",
  color: theme.palette.grey,
  "&:hover": {
    backgroundColor: theme.palette.background.default
  }
}));

export const NotificationPopper = styled(Popper)(() => ({
  zIndex: "99999"
}));

export const NotificationPaper = styled(Paper)(() => ({
  padding: ".25rem .5rem"
}));

export const NotificationAnchorContainer = styled(Box)(() => ({
  position: "relative",
  cursor: "pointer"
}));

export const NotificationLoaderContainer = styled(Box)(() => ({
  position: "absolute",
  bottom: "-1.6rem",
  width: "100%"
}));

export const NotificationsBoxContainer = styled(Box)(() => ({
  maxHeight: "200px",
  overflow: "auto",
  "&::-webkit-scrollbar": {
    width: "0.4rem",
    backgroundColor: "rgb(243 244 246)"
  },
  "&&::-webkit-scrollbar-thumb": {
    borderRadius: "0.75rem",
    backgroundColor: "rgb(209 213 219)"
  },
  /* For Firefox and other browsers that don't support -webkit-scrollbar */
  scrollbarWidth: "thin",
  scrollbarColor: "rgb(209 213 219) rgb(243 244 246)"
}));
